import { LoaderSlice, updateLoader } from "../Store/Slices/LoaderSlice";
import { store } from "../Store/Store";


export const loader = {
    start: () => store.dispatch(updateLoader(true)),
    stop:()=> store.dispatch(updateLoader(false))
}